import React from 'react';
import { bool, func } from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { maxBy, without } from 'lodash-es';
import DateTimePicker from '../../DateTimePicker';
import { API_DATE_FORMAT } from '../../../constants';
import { langType, withLang } from '../../../i18n';
import styles from './reminderScheduling.module.css';
import { surveyOptionsType } from '../../../constants/types';
import { updateSurveyOptionsAction } from '../../../actions';

const ReminderScheduling = ({
  lang, surveyOptions, dispatchUpdate, showProblems
}) => {
  const schedules = surveyOptions.reminderSchedules
    .map((dateTime, index) => ({ id: index, value: dateTime }));
  const updateSchedules = (newSchedules) => dispatchUpdate({
    reminderSchedules: newSchedules.map((schedule) => schedule.value)
  });
  const createId = () => (maxBy(schedules, 'id') || 0) + 1;
  const addSchedule = () => updateSchedules([...schedules, { id: createId(), value: '' }]);
  const removeSchedule = (schedule) => updateSchedules(without(schedules, schedule));
  const updateSchedule = (schedule, dateTime) => {
    schedule.value = dateTime;
    updateSchedules(schedules);
  };

  return (
    <div id="reminderSchedules" className={showProblems ? 'formError' : ''}>
      {schedules.map((schedule) => (
        <div key={schedule.id} className={styles.reminderSchedule}>
          <DateTimePicker
            fieldName={`schedule-${schedule.id}`}
            defaultValue={schedule.value}
            dateOutputFormat={API_DATE_FORMAT}
            locale={lang}
            onChange={(dateTime) => updateSchedule(schedule, dateTime)}
          />
          <button
            type="button"
            className={`button icon--remove ${styles.remove}`}
            onClick={() => removeSchedule(schedule)}
          />
        </div>
      ))}
      <button
        type="button"
        className="button--action"
        onClick={addSchedule}
      >
        <Translate id="startSurvey.reminder.addReminderSchedule" />
      </button>
    </div>
  );
};

ReminderScheduling.propTypes = {
  surveyOptions: surveyOptionsType.isRequired,
  showProblems: bool.isRequired,
  ...langType
};

const mapStateToProps = ({ survey }) => ({
  surveyOptions: survey.surveyOptions,
  dispatchUpdate: func.isRequired
});

const mapDispatchToProps = (dispatch) => ({
  dispatchUpdate: (surveyOptions) => dispatch(updateSurveyOptionsAction(surveyOptions))
});

export default connect(mapStateToProps, mapDispatchToProps)(withLang(ReminderScheduling));
